import * as foundations from './foundations';
import * as components from './components';

export const DefaultTheme = {
  styles: {
    global: {
      fontFamily: 'body',
      lineHeight: '24px',
    },
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  ...foundations,
  components: {
    ...components,
  },
};
